@if (data$ | async; as data) {
  <app-efa-generic-link
    [url]="data.urlLink"
    [target]="getTarget(data)"
    >
    @if (data.headline) {
      <p class="headline" [innerHTML]="data.headline"></p>
    }
    <app-efa-media [container]="data.media"></app-efa-media>
    @if (data.content) {
      <p class="content" [innerHTML]="data.content"></p>
    }
  </app-efa-generic-link>
}
